import { ReactNode } from 'react';
import Header from './Header';
import RoleAssumptionBanner from './RoleAssumptionBanner';
import { FeatureGate } from '../FeatureGate';
import './MainLayout.css';

interface MainLayoutProps {
  children: ReactNode;
  /** When true, removes padding from main content for full-bleed layouts */
  noPadding?: boolean;
}

export default function MainLayout({ children, noPadding = false }: MainLayoutProps) {
  return (
    <div className="app-layout">
      <FeatureGate feature="roleAssumption">
        <RoleAssumptionBanner />
      </FeatureGate>
      <Header />
      <main className={`main-content ${noPadding ? 'main-content--no-padding' : ''}`}>
        {children}
      </main>
    </div>
  );
}
